<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button type="button" (click)="backToPage()" title="Back">
        <ion-icon name="chevron-back-outline"></ion-icon>&nbsp;Back
      </ion-button>
    </ion-buttons>
    <ion-title>
      <ion-icon name="people"></ion-icon>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button type="button" (click)="nextPage()" title="Next">
        Next&nbsp;<ion-icon name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" #content>
  <ion-grid class="banner">
    <ion-row>
      <ion-col class="ion-align-self-center margintop"><ion-label class="banner-title">Parties Information</ion-label></ion-col>
    </ion-row>
  </ion-grid>
  <form [formGroup]="partiesForm" class="form form-input margin-top-1rem" *ngIf="accessibleMode!=='VIEW'">
    <ion-card formGroupName="homeTeamParty">
      <ion-card-header>
        <ion-grid>
          <ion-row>
            <ion-card-title>
              {{partiesForm.get('homeTeamParty.hmTeamType')?.value}}
            </ion-card-title>
          </ion-row>
        </ion-grid>
      </ion-card-header>
      <ion-card-content>
        <ion-list>
          <ion-item>
            <ion-input type="text" placeholder="Enter the Name" formControlName="hmTeamName" maxlength="50">
              <div slot="label">Name <ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
          <ion-item *ngIf="partiesForm.get('homeTeamParty.hmTeamName')?.invalid  && partiesForm.get('homeTeamParty.hmTeamName')?.touched">
            <ion-text *ngIf="partiesForm.get('homeTeamParty.hmTeamName')?.hasError('required')" color="danger">Name is required</ion-text>
            <ion-text *ngIf="partiesForm.get('homeTeamParty.hmTeamName')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
          </ion-item>
          <ion-item [ngClass]="{'hidden': hideHomeAwayFields}">
            <ion-input type="text" label="Position" placeholder="Enter the Position" formControlName="hmTeamPosition" maxlength="50"></ion-input>
          </ion-item>
          <ion-item *ngIf="partiesForm.get('homeTeamParty.hmTeamPosition')?.invalid  && partiesForm.get('homeTeamParty.hmTeamPosition')?.touched">
            <ion-text *ngIf="partiesForm.get('homeTeamParty.hmTeamPosition')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
          </ion-item>
          <ion-item [ngClass]="{'hidden': hideHomeAwayFields}">
            <ion-input type="email" label="Email" placeholder="Enter the Email" [email]="true" formControlName="hmTeamEmail" ></ion-input>
          </ion-item>
          <ion-item [ngClass]="{'hidden': hideHomeAwayFields}" *ngIf="partiesForm.get('homeTeamParty.hmTeamEmail')?.invalid  && partiesForm.get('homeTeamParty.hmTeamEmail')?.touched">
            <ion-text color="danger">Please enter the correct email.</ion-text>
          </ion-item>
          <ion-item [ngClass]="{'hidden': hideHomeAwayFields}">
            <ion-input  type="text" label="Comment" placeholder="Enter the Comment" aria-multiline="true" maxlength="500"
              formControlName="hmTeamComment"></ion-input>
          </ion-item>
          <ion-item *ngIf="partiesForm.get('homeTeamParty.hmTeamComment')?.invalid  && partiesForm.get('homeTeamParty.hmTeamComment')?.touched">
            <ion-text *ngIf="partiesForm.get('homeTeamParty.hmTeamComment')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>

    <ion-card formGroupName="homeTMRepParty">
      <ion-card-header>
        <ion-grid>
          <ion-row>
            <ion-card-title>
              {{partiesForm.get('homeTMRepParty.hmTmRepType')?.value}}
            </ion-card-title>
          </ion-row>
        </ion-grid>
      </ion-card-header>
      <ion-card-content>
        <ion-list>
          <ion-item>
            <ion-input type="text" formControlName="hmTmRepName" placeholder="Enter the Name" maxlength="50">
              <div slot="label">Name<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
          <ion-item *ngIf="partiesForm.get('homeTMRepParty.hmTmRepName')?.invalid && partiesForm.get('homeTMRepParty.hmTmRepName')?.touched">
            <ion-text *ngIf="partiesForm.get('homeTMRepParty.hmTmRepName')?.hasError('required')" color="danger">Name is required</ion-text>
            <ion-text *ngIf="partiesForm.get('homeTMRepParty.hmTmRepName')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
          </ion-item>
          <ion-item>
            <ion-input type="text" id="hmTmRepPosition" formControlName="hmTmRepPosition"
              placeholder="Enter the Position" maxlength="50">
              <div slot="label">Position<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
          <ion-item *ngIf="partiesForm.get('homeTMRepParty.hmTmRepPosition')?.invalid && partiesForm.get('homeTMRepParty.hmTmRepPosition')?.touched">
            <ion-text *ngIf="partiesForm.get('homeTMRepParty.hmTmRepPosition')?.hasError('required')" color="danger">Position is required</ion-text>
            <ion-text *ngIf="partiesForm.get('homeTMRepParty.hmTmRepPosition')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
          </ion-item>

          <ion-item>
            <ion-input type="email" formControlName="hmTmRepEmail" placeholder="Enter the Email" [email]="true">
              <div slot="label">Email<ion-text color="danger">*</ion-text></div>
            </ion-input>            
          </ion-item>
          <ion-item *ngIf="partiesForm.get('homeTMRepParty.hmTmRepEmail')?.invalid && partiesForm.get('homeTMRepParty.hmTmRepEmail')?.touched">
            <ion-text color="danger">Please enter the correct email.</ion-text>            
          </ion-item>

          <ion-item>
            <ion-input type="text" label="Comment" id="hmTmRepComment" formControlName="hmTmRepComment"
              placeholder="Enter the Comment" aria-multiline="true" maxlength="500"></ion-input>
          </ion-item>
          <ion-item *ngIf="partiesForm.get('homeTMRepParty.hmTmRepComment')?.invalid && partiesForm.get('homeTMRepParty.hmTmRepComment')?.touched">
            <ion-text *ngIf="partiesForm.get('homeTMRepParty.hmTmRepComment')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>

    <ion-card formGroupName="awayTeamParty">
      <ion-card-header>
        <ion-grid>
          <ion-row>
            <ion-card-title>{{partiesForm.get('awayTeamParty.awayTeamType')?.value}}</ion-card-title>
          </ion-row>
        </ion-grid>
      </ion-card-header>
      <ion-card-content>
        <ion-list>
          <ion-item>
            <ion-input type="text" id="awayTeamName" formControlName="awayTeamName" placeholder="Enter the Name" maxlength="50">
              <div slot="label">Name<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
          <ion-item *ngIf="partiesForm.get('awayTeamParty.awayTeamName')?.invalid && partiesForm.get('awayTeamParty.awayTeamName')?.touched">
            <ion-text *ngIf="partiesForm.get('awayTeamParty.awayTeamName')?.hasError('required')" color="danger">Name is required</ion-text>
            <ion-text *ngIf="partiesForm.get('awayTeamParty.awayTeamName')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
          </ion-item>

          <ion-item [ngClass]="{'hidden': hideHomeAwayFields}">
            <ion-input type="text" label="Position" formControlName="awayTeamPosition" name="awayTeamPosition" maxlength="50"
              placeholder="Enter the Position"></ion-input>
          </ion-item>
          <ion-item *ngIf="partiesForm.get('awayTeamParty.awayTeamPosition')?.invalid && partiesForm.get('awayTeamParty.awayTeamPosition')?.touched">
            <ion-text *ngIf="partiesForm.get('awayTeamParty.awayTeamPosition')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
          </ion-item>

          <ion-item [ngClass]="{'hidden': hideHomeAwayFields}">
            <ion-input type="email" label="Email" formControlName="awayTeamEmail" name="awayTeamEmail" [email]="true"
              placeholder="Enter the Email"></ion-input>
          </ion-item>
          <ion-item [ngClass]="{'hidden': hideHomeAwayFields}" *ngIf="partiesForm.get('awayTeamParty.awayTeamEmail')?.invalid && partiesForm.get('awayTeamParty.awayTeamEmail')?.touched">
            <ion-text color="danger">Please enter the correct email.</ion-text>
          </ion-item>

          <ion-item [ngClass]="{'hidden': hideHomeAwayFields}">
            <ion-input type="text" label="comment" formControlName="awayTeamComment" name="awayTeamComment" maxlength="500"
              placeholder="Enter the Comment" aria-multiline="true"></ion-input>
          </ion-item>
          <ion-item *ngIf="partiesForm.get('awayTeamParty.awayTeamComment')?.invalid && partiesForm.get('awayTeamParty.awayTeamComment')?.touched">
            <ion-text *ngIf="partiesForm.get('awayTeamParty.awayTeamComment')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>

    <ion-card formGroupName="awayTMrepParty">
      <ion-card-header>
        <ion-grid>
          <ion-row>
            <ion-card-title>{{partiesForm.get('awayTMrepParty.awayTMrepType')?.value}}</ion-card-title>
          </ion-row>
        </ion-grid>
      </ion-card-header>
      <ion-card-content>
        <ion-list>
          <ion-item>
            <ion-input type="text" id="awayTMrepName" formControlName="awayTMrepName" placeholder="Enter the Name" maxlength="50">
              <div slot="label">Name<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
          <ion-item *ngIf="partiesForm.get('awayTMrepParty.awayTMrepName')?.invalid && partiesForm.get('awayTMrepParty.awayTMrepName')?.touched">
            <ion-text *ngIf="partiesForm.get('awayTMrepParty.awayTMrepName')?.hasError('required')" color="danger">Name is required</ion-text>
            <ion-text *ngIf="partiesForm.get('awayTMrepParty.awayTMrepName')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
          </ion-item>

          <ion-item>
            <ion-input type="text" id="awayTMrepPosition" formControlName="awayTMrepPosition" maxlength="50"
              placeholder="Enter the Position">
              <div slot="label">Position<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
          <ion-item *ngIf="partiesForm.get('awayTMrepParty.awayTMrepPosition')?.invalid && partiesForm.get('awayTMrepParty.awayTMrepPosition')?.touched">
            <ion-text *ngIf="partiesForm.get('awayTMrepParty.awayTMrepPosition')?.hasError('required')"color="danger">Position is required</ion-text>
            <ion-text *ngIf="partiesForm.get('awayTMrepParty.awayTMrepPosition')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
          </ion-item>

          <ion-item>
            <ion-input type="email" id="awayTMrepEmail" [email]="true" formControlName="awayTMrepEmail" placeholder="Enter the Email">
              <div slot="label">Email<ion-text color="danger">*</ion-text></div>
            </ion-input>
          </ion-item>
          <ion-item *ngIf="partiesForm.get('awayTMrepParty.awayTMrepEmail')?.invalid && partiesForm.get('awayTMrepParty.awayTMrepEmail')?.touched">
            <ion-text color="danger">Please enter the correct email.</ion-text>
          </ion-item>

          <ion-item>
            <ion-input type="text" id="awayTMrepComment" label="Comment" formControlName="awayTMrepComment" maxlength="500"
              placeholder="Enter the Comment" aria-multiline="true"></ion-input>
          </ion-item>
          <ion-item *ngIf="partiesForm.get('awayTMrepParty.awayTMrepComment')?.invalid && partiesForm.get('awayTMrepParty.awayTMrepComment')?.touched">
            <ion-text *ngIf="partiesForm.get('awayTMrepParty.awayTMrepComment')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
          </ion-item>

        </ion-list>
      </ion-card-content>
    </ion-card>
    <ng-container formArrayName="parties">
      <ion-card *ngFor="let prtyFrm of parties.controls; let idx = index" [formGroupName]="idx">
        <ion-card-header>
          <ion-grid>
            <ion-row>
              <ion-col></ion-col>
              <ion-col class="text-align-right">
                <ion-icon name="trash-outline" size="small" (click)="removeParty(idx)"></ion-icon>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-header>
        <ion-card-content>
          <ion-list>
            <ion-item>
              <ion-select justify="justify-center" formControlName="type" placeholder="Select a Type">
                <div slot="label">Type <ion-text color="danger">*</ion-text></div>
                <ion-select-option *ngFor="let partyType of partyTypeList" [value]="partyType">{{partyType}}</ion-select-option>
              </ion-select>

            </ion-item>
            <ion-item *ngIf="prtyFrm.get('type')?.invalid && prtyFrm.get('type')?.touched">
              <ion-text color="danger">Type is required</ion-text>
            </ion-item>
            <ion-item>
              <ion-input type="text" name="name" formControlName="name" placeholder="Enter the Name" maxlength="50">
                <div slot="label">Name <ion-text color="danger">*</ion-text></div>
              </ion-input>              
            </ion-item>
            <ion-item *ngIf="prtyFrm.get('name')?.invalid && prtyFrm.get('name')?.touched">
              <ion-text *ngIf="prtyFrm.get('name')?.hasError('required')" color="danger">Name is required</ion-text>
              <ion-text *ngIf="prtyFrm.get('name')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
            </ion-item>

            <ion-item>
              <ion-input type="text" label="Position" id="position" formControlName="position" maxlength="50"
                placeholder="Enter the Position"></ion-input>
            </ion-item>
            <ion-item *ngIf="prtyFrm.get('position')?.invalid && prtyFrm.get('position')?.touched">
              <ion-text *ngIf="prtyFrm.get('position')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
            </ion-item>

            <ion-item>
              <ion-input type="email" [email]="true" formControlName="email" placeholder="Enter the Email">
                <div slot="label">Email<ion-text color="danger">*</ion-text></div>
              </ion-input>              
            </ion-item>
            <ion-item *ngIf="prtyFrm.get('email')?.invalid && prtyFrm.get('email')?.touched">
              <ion-text color="danger">Please enter the correct email.</ion-text>
            </ion-item>
            <ion-item>
              <ion-input type="text" label="Comment" placeholder="Enter the Comment" formControlName="comment" maxlength="500" aria-multiline="true"></ion-input>
            </ion-item>
            <ion-item *ngIf="prtyFrm.get('comment')?.invalid && prtyFrm.get('position')?.touched">
              <ion-text *ngIf="prtyFrm.get('comment')?.hasError('pattern')" color="danger">Special characters are not allowed</ion-text>
            </ion-item>
          </ion-list>
        </ion-card-content>
      </ion-card>
      <ion-button expand="block" (click)="addNewParty()">ADD NEW Party</ion-button>
    </ng-container>
  </form>

  <ion-grid>
    <ion-row *ngIf="accessibleMode==='VIEW'">
      <ion-col>
        <ion-card class="view-mode">
          <ion-card-header>
            <ion-grid class="myChecklist">
              <ion-row>
                <ion-col>
                  <ion-card-title>{{partiesForm.get('homeTeamParty.hmTeamName')?.value}}</ion-card-title>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="margin-auto">
                  <ion-card-subtitle>{{partiesForm.get('homeTeamParty.hmTeamType')?.value}}</ion-card-subtitle>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card-header>
          <ion-card-content [ngClass]="{'hidden': hideHomeAwayFields}">
            <ion-list>
              <ion-item>
                <ion-label class="item-title">Position</ion-label>
                <ion-label class="item-content" *ngIf="partiesForm.get('homeTeamParty.hmTeamPosition')">{{partiesForm.get('homeTeamParty.hmTeamPosition')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!partiesForm.get('homeTeamParty.hmTeamPosition')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">Email</ion-label>
                <ion-label class="item-content" *ngIf="partiesForm.get('homeTeamParty.hmTeamEmail')">{{partiesForm.get('homeTeamParty.hmTeamEmail')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!partiesForm.get('homeTeamParty.hmTeamEmail')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">Comment</ion-label>
                <ion-label class="item-content" *ngIf="partiesForm.get('homeTeamParty.hmTeamComment')">{{partiesForm.get('homeTeamParty.hmTeamComment')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!partiesForm.get('homeTeamParty.hmTeamComment')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
            </ion-list>
          </ion-card-content>
        </ion-card>

        <ion-card class="view-mode">
          <ion-card-header>
            <ion-grid class="myChecklist">
              <ion-row>
                <ion-col>
                  <ion-card-title>{{partiesForm.get('homeTMRepParty.hmTmRepName')?.value}}</ion-card-title>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="margin-auto">
                  <ion-card-subtitle>{{partiesForm.get('homeTMRepParty.hmTmRepType')?.value}}</ion-card-subtitle>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card-header>
          <ion-card-content>
            <ion-list>
              <ion-item>
                <ion-label class="item-title">Position</ion-label>
                <ion-label class="item-content" *ngIf="partiesForm.get('homeTMRepParty.hmTmRepPosition')">{{partiesForm.get('homeTMRepParty.hmTmRepPosition')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!partiesForm.get('homeTMRepParty.hmTmRepPosition')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">Email</ion-label>
                <ion-label class="item-content" *ngIf="partiesForm.get('homeTMRepParty.hmTmRepEmail')">{{partiesForm.get('homeTMRepParty.hmTmRepEmail')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!partiesForm.get('homeTMRepParty.hmTmRepEmail')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">Comment</ion-label>
                <ion-label class="item-content" *ngIf="partiesForm.get('homeTMRepParty.hmTmRepComment')">{{partiesForm.get('homeTMRepParty.hmTmRepComment')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!partiesForm.get('homeTMRepParty.hmTmRepComment')?.value">&lt;empty&gt;</ion-label>                
              </ion-item>
            </ion-list>
          </ion-card-content>
        </ion-card>

        <ion-card  class="view-mode">
          <ion-card-header>
            <ion-grid class="myChecklist">
              <ion-row>
                <ion-col>
                  <ion-card-title>{{partiesForm.get('awayTeamParty.awayTeamName')?.value}}</ion-card-title>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="margin-auto">
                  <ion-card-subtitle>{{partiesForm.get('awayTeamParty.awayTeamType')?.value}}</ion-card-subtitle>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card-header>
          <ion-card-content [ngClass]="{'hidden': hideHomeAwayFields}">
            <ion-list>
              <ion-item>
                <ion-label class="item-title">Position</ion-label>
                <ion-label class="item-content" *ngIf="partiesForm.get('awayTeamParty.awayTeamPosition')">{{partiesForm.get('awayTeamParty.awayTeamPosition')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!partiesForm.get('awayTeamParty.awayTeamPosition')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">Email</ion-label>
                <ion-label class="item-content" *ngIf="partiesForm.get('awayTeamParty.awayTeamEmail')">{{partiesForm.get('awayTeamParty.awayTeamEmail')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!partiesForm.get('awayTeamParty.awayTeamEmail')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">Comment</ion-label>
                <ion-label class="item-content" *ngIf="partiesForm.get('awayTeamParty.awayTeamComment')">{{partiesForm.get('awayTeamParty.awayTeamComment')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!partiesForm.get('awayTeamParty.awayTeamComment')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
            </ion-list>
          </ion-card-content>
        </ion-card>

        <ion-card  class="view-mode">
          <ion-card-header>
            <ion-grid class="myChecklist">
              <ion-row>
                <ion-col>
                  <ion-card-title>{{partiesForm.get('awayTMrepParty.awayTMrepName')?.value}}</ion-card-title>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="margin-auto">
                  <ion-card-subtitle>{{partiesForm.get('awayTMrepParty.awayTMrepType')?.value}}</ion-card-subtitle>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card-header>
          <ion-card-content>
            <ion-list>
              <ion-item>
                <ion-label class="item-title">Position</ion-label>
                <ion-label class="item-content" *ngIf="partiesForm.get('awayTMrepParty.awayTMrepPosition')">{{partiesForm.get('awayTMrepParty.awayTMrepPosition')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!partiesForm.get('awayTMrepParty.awayTMrepPosition')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">Email</ion-label>
                <ion-label class="item-content" *ngIf="partiesForm.get('awayTMrepParty.awayTMrepEmail')">{{partiesForm.get('awayTMrepParty.awayTMrepEmail')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!partiesForm.get('awayTMrepParty.awayTMrepEmail')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">Comment</ion-label>
                <ion-label class="item-content" *ngIf="partiesForm.get('awayTMrepParty.awayTMrepComment')">{{partiesForm.get('awayTMrepParty.awayTMrepComment')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!partiesForm.get('awayTMrepParty.awayTMrepComment')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
            </ion-list>
          </ion-card-content>
        </ion-card>
        <ng-container>
        <ion-card  *ngFor="let prtyFrm of parties.controls;" class="view-mode">
          <ion-card-header>
            <ion-grid class="myChecklist">
              <ion-row>
                <ion-col>
                  <ion-card-title>{{prtyFrm.get('name')?.value}}</ion-card-title>                  
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="margin-auto">
                  <ion-card-subtitle>{{prtyFrm.get('type')?.value}}</ion-card-subtitle>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card-header>
          <ion-card-content>
            <ion-list>
              <ion-item>
                <ion-label class="item-title">Position</ion-label>
                <ion-label class="item-content" *ngIf="prtyFrm.get('position')">{{prtyFrm.get('position')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!prtyFrm.get('position')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">Email</ion-label>
                <ion-label class="item-content" *ngIf="prtyFrm.get('email')">{{prtyFrm.get('email')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!prtyFrm.get('email')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
      
              <ion-item>
                <ion-label class="item-title">Comment{{prtyFrm.get('comment')?.value}}</ion-label>
                <ion-label class="item-content" *ngIf="prtyFrm.get('comment')">{{prtyFrm.get('comment')?.value}}</ion-label>
                <ion-label class="item-content item-empty-content" *ngIf="!prtyFrm.get('comment')?.value">&lt;empty&gt;</ion-label>
              </ion-item>
            </ion-list>
          </ion-card-content>
        </ion-card>
        </ng-container>
      </ion-col>
    </ion-row>
  </ion-grid>

</ion-content>